import { Divider as DividerAntd, DividerProps } from 'antd';
import React from 'react';
import styles from './divider.module.scss';

const Divider: React.FC<DividerProps> = props => {
	return <DividerAntd {...props} className={props.className ?? styles.divider} />;
};

export { Divider };
